export const wrapHBSTemplatesAndReplaceNewLinesWithBRTags = (input: string) => {
  // Regex to match Handlebars templates: {{ ... }} or {{{ ... }}}
  const handlebarsRegex = /{{[^{}]*("|')[^{}]*\1[^{}]*}}|{{[^{}]+}}/g;
  
  // First encode any HTML in the template
  let wrappedString = input.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  // Next, add HTML: replace each match with the same content wrapped in <b> tags
  wrappedString = wrappedString.replace(handlebarsRegex, '<code class="hbs-template">$&</code>');
  wrappedString = wrappedString.replaceAll('\r\n', '<br />').replaceAll('\n', '<br />');
  
  return wrappedString;
}